import { render, staticRenderFns } from "./UserDevices.vue?vue&type=template&id=bd2a7e38&scoped=true&"
import script from "./UserDevices.vue?vue&type=script&lang=js&"
export * from "./UserDevices.vue?vue&type=script&lang=js&"
import style0 from "./UserDevices.vue?vue&type=style&index=0&id=bd2a7e38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2a7e38",
  null
  
)

component.options.__file = "UserDevices.vue"
export default component.exports